import {useGetMaterial} from "@project/application/engineering/materials";
import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute, useParams} from "@tanstack/react-router";
import {useRef} from "react";

import {Route as MaterialRoute} from "./route";

export const Route = createFileRoute("/_app/engineering/materials/$materialId/")({
  component: IndexRouteComponent,
});

function IndexRouteComponent() {
  const {materialId} = useParams({strict: false}) as {materialId: string};
  const {includeDeleted} = MaterialRoute.useSearch();
  const {data: material} = useGetMaterial(materialId, includeDeleted);
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop && material?.materialId === materialId) {
    if (material.compositionKind === "COMPOSITE")
      return (
        <Navigate
          replace
          params={{materialId}}
          search={{includeDeleted}}
          to={routes.engineering.materials.material().composition()}
        />
      );
    return (
      <Navigate
        replace
        params={{materialId}}
        search={{
          page: 1,
          perPage: 10,
          state: "ACTIVE",
          sortKey: "supplierId",
          sortDir: "asc",
          includeDeleted,
        }}
        to={routes.engineering.materials.material().offers()}
      />
    );
  }

  return <div ref={ref} className="h-full w-full" />;
}
